export default __webpack_public_path__ + "static/assets/ac835879063d69ed48f21b8fa132a014.png";